import CampaignIndexHeaderComponent from '../Admin/Campaign/CampaignIndex/HeaderComponent'
import MerchantIndexHeaderComponent from '../Admin/Merchant/MerchantIndex/HeaderComponent'
import PartnerIndexHeaderComponent from '../Admin/Partner/PartnerIndex/HeaderComponent'
import CategoryIndexHeaderComponent from './Category/CategoryIndex/HeaderComponent'
import POSIndexHeaderComponent from './POS/POSIndex/HeaderComponent'
import UserIndexHeaderComponent from './User/UserIndex/HeaderComponent'
import VoucherIndexHeaderComponent from './Voucher/VoucherIndex/HeaderComponent'

const AdminHeader = () => {
  const headers = [
    {
      routes: ['admin.campaigns.index'],
      component: <CampaignIndexHeaderComponent />,
    },
    {
      routes: ['admin.merchants.index'],
      component: <MerchantIndexHeaderComponent />,
    },
    {
      routes: ['admin.partners.index'],
      component: <PartnerIndexHeaderComponent />,
    },
    {
      routes: ['admin.vouchers.index'],
      component: <VoucherIndexHeaderComponent />,
    },
    {
      routes: ['admin.categories.index'],
      component: <CategoryIndexHeaderComponent />,
    },
    {
      routes: ['admin.pos.index'],
      component: <POSIndexHeaderComponent />,
    },
    {
      routes: ['admin.users.index'],
      component: <UserIndexHeaderComponent />,
    },
  ]

  const header = headers.find(({ routes }) => routes.some((r) => r === route().current()))

  return header?.component ?? null
}

export default AdminHeader
